import React from "react";
import "../styles/About.scss";

export function About() {
  return (
    <section id="about" className="about">
      <div className="text-section">
        <h3>ABOUT ME</h3>
        <div className="underline-decoration"></div>
        <p>
          I am a Full Stack Web Developer that enjoys challenges and learning
          new things. I tend to indulge myself in code and solving complicated
          problems. Building creative and interactive applications is a passion
          of mine.
        </p>
        <p>
          I also enjoy debugging and fixing problems in existing code bases. I
          feel that it is important to learn from the mistakes made and that I
          can benefit from the experience of finding the solution to a problem.
        </p>
      </div>
      <div className="image-section">
        <div className="image-back-hollow"></div>
        <div className="image-back-solid"></div>
        <div className="image-container">
          <img
            src={require("../assets/images/portrait.jpg")}
            alt="Chris Adams"
          />
        </div>
      </div>
    </section>
  );
}
